import { ActionGeneratorBuilder } from 'core/redux/actions';

export const actions = new ActionGeneratorBuilder('mqttClients')
	.subtype('add', (add) => add.request('data').success('data').fail().cancel())
	.subtype('load', (load) => load.request().success('mqttClients').fail().cancel())
	.subtype('update', (update) => update.request({ clientId: true, data: true }).success('data').fail().cancel())
	.subtype('remove', (remove) => remove.request('clientId').success().fail().cancel())
	.type('clear')
	.build();
